import mapResponseToInvoiceSettings from './mappers/mapResponseToInvoiceSettings'

export default function fetchTaxes(api: GlobalFetch) {
  return async function() {
    const buildUrl = `/api/v2/invoice/settings`
    const response = await api.fetch(buildUrl)
    const responseBody: IData = await response.json()

    return mapResponseToInvoiceSettings(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_object: string
  active_tax: string
  active_second_tax: string
  default_tax_name: string
  default_second_tax_name: string
  default_tax_rate: string
  default_second_tax_rate: string
  created_at: string
  updated_at: string
  show_dates_on_invoice: string
}
